// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/RequestItem/index.css
// module id = 2247
// module chunks = 0